var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.menu.children && _vm.menu.children.length >= 1
    ? _c(
        "el-submenu",
        { attrs: { index: "" + _vm.menu.id } },
        [
          _c("template", { slot: "title" }, [
            _c("i", { class: _vm.menu.icon }),
            _vm._v(" "),
            _c("span", { attrs: { slot: "title" }, slot: "title" }, [
              _vm._v(_vm._s(_vm.$t(_vm.menu.name)))
            ])
          ]),
          _vm._v(" "),
          _vm._l(_vm.menu.children, function(item) {
            return _c("MenuTree", { key: item.id, attrs: { menu: item } })
          })
        ],
        2
      )
    : _c(
        "el-menu-item",
        {
          attrs: { index: "" + _vm.menu.id },
          on: {
            click: function($event) {
              return _vm.handleRoute(_vm.menu)
            }
          }
        },
        [
          _c("i", { class: _vm.menu.icon }),
          _vm._v(" "),
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t(_vm.menu.name)))
          ])
        ]
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9c434fe0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c434fe0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MenuTree/index.vue
// module id = null
// module chunks = 